export var LabelTooltip = {
  Auto: 'auto',
  On: 'on',
  Off: 'off'
};